export const KEY = 'donationsSeedPage';

export const INIT = 'app/DonationsSeedPage/INIT';
export const INIT_SUCCESS = 'app/DonationsSeedPage/INIT_SUCCESS';
export const INIT_FAILED = 'app/DonationsSeedPage/INIT_FAILED';
